const getPropsToDisplayModifiers = propsToDisplay => propsToDisplay.map(({
  modifier
}) => modifier || '');
export default getPropsToDisplayModifiers;
//# sourceMappingURL=get-props-to-display-modifiers.js.map